import RouterTabs, { RouterTabOption } from 'lib/components/RouterTabs';
import { getDynamicRoute } from 'lib/frontend/utils/router';
import { OrderModel } from 'lib/model/objects/orderModel';
import { ProductToRoutesMap, useSyncAttempts } from './useSyncAttempts';

type OrderDetailDrawerTabsProps = {
  order: OrderModel;
};

export default function OrderDetailDrawerTabs({
  order
}: OrderDetailDrawerTabsProps) {
  const syncAttempts = useSyncAttempts(order.ref);
  const routes = ProductToRoutesMap[order.modelData.product];

  const tabs: RouterTabOption[] = routes
    ? [
        {
          label: 'Preview',
          enabled: true,
          path: getDynamicRoute(routes.PREVIEW, { id: order.id })
        },
        {
          label: 'Activity',
          enabled: true,
          path: getDynamicRoute(routes.ACTIVITY, { id: order.id })
        },
        {
          label: 'Sync Attempts',
          enabled: syncAttempts.length > 0,
          path: getDynamicRoute(routes.SYNC_ATTEMPTS, { id: order.id })
        }
      ]
    : [];

  return (
    <div className="h-full flex flex-col">
      <RouterTabs tabs={tabs} id="order-detail-drawer-tabs" hideDisabled />
    </div>
  );
}
